/* ====================================================================
   Sensor-1 — "Install Sensor-1 App"
   --------------------------------------------------------------------
   Adds an install control beside the account/login icon in the header
   (and optionally in the mobile menu), captures the browser's
   beforeinstallprompt where available, and otherwise shows short
   device-specific instructions.

   No jQuery, no third-party libraries, no service worker, no caching,
   and no personal data. The header control is injected at runtime so
   the theme's own section files stay untouched.
   ==================================================================== */
(function () {
  'use strict';

  if (window.__s1PwaInit) return; /* never bind twice */
  window.__s1PwaInit = true;

  var doc = document;

  var ICONS = {
    download: '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line>',
    device: '<rect x="6" y="2" width="12" height="20" rx="2" ry="2"></rect><line x1="12" y1="8" x2="12" y2="14"></line><line x1="9" y1="11" x2="15" y2="11"></line><line x1="11" y1="18" x2="13" y2="18"></line>'
  };

  function svg(name, cls) {
    var paths = ICONS[name] || ICONS.download;
    return '<svg class="pwa-install-trigger__icon ' + (cls || '') + '" xmlns="http://www.w3.org/2000/svg" ' +
      'width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + paths + '</svg>';
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function ready(fn) {
    if (doc.readyState === 'loading') {
      doc.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  ready(function () {
    var cfgEl = doc.getElementById('pwa-install-config');
    if (!cfgEl) return; /* feature disabled in the theme editor */

    var cfg = {
      dismissDays: 7,
      analytics: true,
      buttonText: 'Install Sensor-1 App',
      icon: 'download',
      showInHeader: true,
      showInMobileMenu: false
    };
    try {
      var parsed = JSON.parse(cfgEl.textContent);
      for (var k in parsed) {
        if (Object.prototype.hasOwnProperty.call(parsed, k)) cfg[k] = parsed[k];
      }
    } catch (err) { /* keep defaults */ }

    var label = cfg.buttonText || 'Install Sensor-1 App';
    var designMode = !!(window.Shopify && window.Shopify.designMode);

    /* ---------------- show the login icon on phones ----------------
       Prestige tags the account/login item with the utility class
       "sm-max:hidden", which hides it below 700px, so phones only ever
       showed search and cart. Merchant preference (2026-07-31): every
       header icon stays visible on every screen size. */
    function unhideAccountLink() {
      var accountItem = doc.querySelector('.header__secondary-nav .header__account-link');
      if (accountItem) accountItem.classList.remove('sm-max:hidden');
    }

    /* ---------------- inject the header control ---------------- */
    function injectHeader() {
      if (!cfg.showInHeader) return;
      if (doc.querySelector('.header__pwa-install')) return; /* no duplicates */

      var accountItem = doc.querySelector('.header__secondary-nav .header__account-link');
      var list = accountItem
        ? accountItem.parentNode
        : doc.querySelector('.header__secondary-nav ul');
      if (!list) return;

      /* Mirror the theme: if neighbouring links show a text label next to
         their icon, show one too; otherwise stay icon-only. */
      var neighbour = doc.querySelector(
        '.header__secondary-nav .header__account-link a .link-faded, ' +
        '.header__secondary-nav .header__cart-link a .link-faded'
      );
      var showsLabel = !!neighbour;
      var headingClass = neighbour && neighbour.classList.contains('h6') ? 'h6' : '';

      var item = doc.createElement('li');
      item.className = 'header__pwa-install';
      if (!designMode) item.setAttribute('hidden', '');
      item.setAttribute('data-pwa-install-host', '');

      var inner = '<button type="button" class="pwa-install-trigger" data-pwa-install-trigger ' +
        'aria-haspopup="dialog" title="' + escapeHtml(label) + '">' +
        '<span class="sr-only">' + escapeHtml(label) + '</span>';

      if (showsLabel) {
        inner += '<span class="md:hidden">' + svg(cfg.icon, 'header__nav-icon') + '</span>' +
          '<span class="' + headingClass + ' link-faded md-max:hidden" aria-hidden="true">' +
          escapeHtml(label) + '</span>';
      } else {
        inner += svg(cfg.icon, 'header__nav-icon');
      }

      inner += '</button>';
      item.innerHTML = inner;

      if (accountItem) {
        list.insertBefore(item, accountItem);
      } else {
        list.appendChild(item);
      }
    }

    /* ---------------- inject the mobile-menu button ---------------- */
    function injectSidebar() {
      if (!cfg.showInMobileMenu) return;
      if (doc.querySelector('.header-sidebar__pwa')) return;

      var panel = doc.querySelector('.header-sidebar__main-panel');
      if (!panel) return;

      var wrap = doc.createElement('div');
      wrap.className = 'header-sidebar__pwa';
      if (!designMode) wrap.setAttribute('hidden', '');
      wrap.setAttribute('data-pwa-install-host', '');
      wrap.innerHTML = '<button type="button" class="button w-full pwa-install-trigger" ' +
        'data-pwa-install-trigger aria-haspopup="dialog">' +
        '<span class="text-with-icon">' + svg(cfg.icon, '') + escapeHtml(label) + '</span></button>';

      var footer = panel.querySelector('.header-sidebar__footer');
      if (footer) {
        panel.insertBefore(wrap, footer);
      } else {
        panel.appendChild(wrap);
      }
    }

    unhideAccountLink();
    injectHeader();
    injectSidebar();

    /* The header and menu are re-rendered when a merchant edits a section
       in the theme editor, so re-inject afterwards. */
    if (designMode) {
      doc.addEventListener('shopify:section:load', function () {
        unhideAccountLink();
        injectHeader();
        injectSidebar();
      });
      return; /* never run install logic inside the editor */
    }

    var DISMISS_KEY = 's1PwaDismissedAt';
    var INSTALL_KEY = 's1PwaInstalled';
    var deferredPrompt = null;
    var revealed = false;
    var shownTracked = false;
    var lastTrigger = null;

    function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
    function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* private mode */ } }

    function hosts() {
      return Array.prototype.slice.call(doc.querySelectorAll('[data-pwa-install-host]'));
    }

    function isStandalone() {
      return (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) ||
        window.navigator.standalone === true;
    }

    function recentlyDismissed() {
      /* Merchant preference (2026-07-30): the install button should always
         stay visible, even after a customer dismisses the prompt. */
      return false;
    }

    /* ---------------- platform detection ---------------- */
    var ua = navigator.userAgent;
    var isIOS = /iPhone|iPad|iPod/.test(ua) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1); /* iPadOS */
    var isAndroid = /Android/.test(ua);
    var isMac = /Macintosh/.test(ua) && !isIOS;

    /* Always resolves to a set of instructions. Previously this returned
       null for iPhone/iPad browsers other than Safari and for desktops
       that are neither Mac nor Windows (Linux, ChromeOS, anything with an
       unusual user agent), and the button then stayed hidden on those
       machines. */
    function platformKey() {
      if (isIOS) return 'apple';   /* Safari, Chrome and Firefox on iOS all use Share -> Add to Home Screen */
      if (isAndroid) return 'android';
      if (isMac) return 'mac';
      return 'windows';            /* Windows, Linux, ChromeOS and anything unrecognised */
    }

    /* ---------------- analytics (no personal data) ---------------- */
    function track(name) {
      if (!cfg.analytics) return;
      try {
        if (window.Shopify && window.Shopify.analytics &&
          typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish(name, { source: 'sensor1-pwa' });
        }
      } catch (e) { /* noop */ }
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: name, source: 'sensor1-pwa' });
      } catch (e) { /* noop */ }
    }

    /* ---------------- show / hide ---------------- */
    function reveal() {
      if (revealed) return;
      revealed = true;
      hosts().forEach(function (el) { el.removeAttribute('hidden'); });
      if (!shownTracked) { shownTracked = true; track('pwa_button_shown'); }
    }

    function conceal() {
      revealed = false;
      hosts().forEach(function (el) { el.setAttribute('hidden', ''); });
    }

    /* ---------------- instruction dialogs ---------------- */
    function openModal(key) {
      var dialog = doc.getElementById('pwa-modal-' + key);
      if (!dialog) return;
      if (typeof dialog.showModal === 'function') {
        if (!dialog.open) dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      var close = dialog.querySelector('[data-pwa-modal-close]');
      if (close) close.focus();
      track('pwa_instructions_' + key + '_shown');
    }

    function closeModal(dialog) {
      if (typeof dialog.close === 'function' && dialog.open) {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
      if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
    }

    /* ---------------- one delegated click listener ---------------- */
    doc.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;

      var trigger = target.closest('[data-pwa-install-trigger]');
      if (trigger) {
        event.preventDefault();
        lastTrigger = trigger;
        track('pwa_button_clicked');

        if (deferredPrompt) {
          var promptEvent = deferredPrompt;
          deferredPrompt = null; /* a captured prompt is single-use */
          promptEvent.prompt();
          promptEvent.userChoice.then(function (choice) {
            if (choice && choice.outcome === 'accepted') {
              track('pwa_install_accepted');
            } else {
              /* Merchant preference: keep the button visible after a
                 dismissal and do not record a cool-down period. */
              track('pwa_install_dismissed');
            }
          })['catch'](function () { /* noop */ });
          return;
        }

        openModal(platformKey());
        return;
      }

      var closeBtn = target.closest('[data-pwa-modal-close]');
      if (closeBtn) {
        var dlg = closeBtn.closest('dialog.pwa-modal');
        if (dlg) closeModal(dlg);
        return;
      }

      if (target.nodeName === 'DIALOG' && target.classList.contains('pwa-modal')) {
        closeModal(target); /* backdrop click */
      }
    });

    Array.prototype.forEach.call(doc.querySelectorAll('dialog.pwa-modal'), function (dialog) {
      dialog.addEventListener('close', function () {
        if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
      });
    });

    /* ---------------- decide whether to offer installing ---------------- */
    /* Merchant preference (2026-07-31): the button acts as a permanent
       "Link to Sensor-1 website" tile, so it stays visible even after the
       app is installed. It is hidden only inside the installed app window
       itself, where it would serve no purpose. */
    if (isStandalone()) return;

    window.addEventListener('beforeinstallprompt', function (event) {
      event.preventDefault();
      deferredPrompt = event;
      reveal();
    });

    window.addEventListener('appinstalled', function () {
      lsSet(INSTALL_KEY, '1');
      deferredPrompt = null;
      track('pwa_install_accepted');
    });

    /* Show the tile straight away on every browser and platform. Where the
       browser later offers a native install prompt it is captured above and
       used on click; everywhere else the click opens the device
       instructions. Previously the tile waited 2.5 seconds for a native
       prompt, and never appeared at all on unrecognised platforms. */
    reveal();
  });
})();
